import { Component, Input } from '@angular/core';
import { CompositeFilterDescriptor } from '../../composite-filter-descriptor';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './drop-down-filter.component.html',
})
export class DropDownFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): any {
    const filter = this.filterByField(this.field);
    return filter ? filter.value : null;
  }

  @Input() public field: string;

  @Input() public filter: CompositeFilterDescriptor;
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;

  public get defaultItem(): any {
    return {
      [this.textField]: 'Select...',
      [this.valueField]: null,
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(value: any): void {
    this.applyFilter(
      value === null // value of the default item
        ? this.removeFilter(this.field) // remove the filter
        : this.updateFilter({
            // add a filter for the field with the value
            field: this.field,
            operator: 'eq',
            value: value,
          }),
    ); // update the root filter
  }
}
